import React from 'react';
import ReconciliationList from "../components/reconcelation/ReconcelationList";


const Reconciliation = () => {

    return (
        <>
            <ReconciliationList rowsPerPage={20}/>
        </>
    );
};

export default Reconciliation;